import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FormlyModule } from '@ngx-formly/core';

import { DirectivesModule } from '@directives/directives.module';

import { TaProjectSelectComponent } from './ta-project-select.component';

import { RequiredValidator } from '../ta-validators';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
    declarations: [TaProjectSelectComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DirectivesModule,
        NgSelectModule,
        FormlyModule.forChild({
            types: [
                {
                    name: 'ta-project-select',
                    component: TaProjectSelectComponent,
                    defaultOptions: {
                        validators: {
                            required: RequiredValidator,
                        }
                    }
                }
            ]
        })
    ]
})
export class TaFormlyProjectSelectModule { }
